import { api } from './api';

export interface AppNotification {
  id: number;
  type: string;
  title: string;
  message: string;
  data?: any;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationsResponse {
  notifications: AppNotification[];
  total: number;
  page: number;
  pages: number;
}

export const notificationService = {
  async getNotifications(page = 1, limit = 20): Promise<NotificationsResponse> {
    const response = await api.get('/notifications', {
      params: { page, limit },
    });
    // Backend wraps response in {success: true, data: {...}}
    return response.data.data;
  },

  async markAsRead(id: number): Promise<void> {
    await api.patch(`/notifications/${id}/read`);
  },

  async markAllAsRead(): Promise<void> {
    await api.patch('/notifications/read-all');
  },

  async deleteNotification(id: number): Promise<void> {
    await api.delete(`/notifications/${id}`);
  },

  async getUnreadCount(): Promise<{ count: number }> {
    const response = await api.get('/notifications/count');
    // Backend wraps response in {success: true, data: {...}}
    return response.data.data;
  },
};